import './css/Configuration.css'
import { HiOutlineClipboard } from 'react-icons/hi'
import { IoPeopleOutline } from 'react-icons/io5'
import {BiSolidUser} from 'react-icons/bi'
import React, { useState,useEffect} from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from "axios"
import api from "../config/backend"
import { toast } from 'react-toastify';
import { Button, IconButton, Tooltip } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
function Configurations({ formdata }) {
    const [selectedOption, setSelectedOption] = useState('message');
    const [message, setMessage] = useState('');
    const [isEditable, setIsEditable] = useState(false);
    
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        setIsEditable(false);
    };
    const token = localStorage.getItem("_crm__token")

    const handleSave = async () => {
        try {
            const response = await axios.post(`${api}/Form/submit-action`, { token, action: selectedOption, actiondata: message });

            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to update form configuration');
        }
    };

    useEffect(() => {
      if (formdata && formdata.submitaction) {
        setSelectedOption(formdata.submitaction.action)
        setMessage(formdata.submitaction.actiondata)
      }
    }, [])
    
    return (
            <div className='app-configuration-page'>
                <div className='app-configuration-page__wrapper'>
                    <div className='app-configuration-page__content'>
                        <div className='app-configuration-page__header'>
                            <Tooltip title="Back">
                                <IconButton size="small">
                                    <ArrowBack />
                                </IconButton>
                            </Tooltip>
                            <h3>What should happen when this form is submitted?</h3>
                        </div>
                        <div className='app-configuration-page__card'>
                            <div className='app-configuration-page__radio'>
                                <label>
                                    <input
                                        type="radio"
                                        value="message"
                                        checked={selectedOption === 'message'}
                                        onChange={handleOptionChange}
                                    />
                                    Thank you message
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="redirect"
                                        checked={selectedOption === 'redirect'}
                                        onChange={handleOptionChange}
                                    />
                                    Redirect to a page
                                </label>
                            </div>
                            <div>
                                {selectedOption === 'message' && (
                                    <div className="app-configuration-page__message">
                                        <p>Here's the message that will appear as soon as the form is submitted by your visitors</p>
                                        <textarea
                                            rows="6"
                                            cols="80"
                                            value={message}
                                            readOnly={!isEditable}
                                            onClick={() => setIsEditable(true)}
                                            onChange={(e) => setMessage(e.target.value)}
                                        />
                                    </div>
                                )}

                                {selectedOption === 'redirect' && (
                                    <div className="app-configuration-page__message">
                                        <p>Add a Redirect URL to an external page</p>
                                        <input
                                            type="text"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            placeholder="http://yourwebsite.com"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className='app-configuration-page__footer'>
                                <Button variant="contained" className="app-btn-contained app-btn-primary" onClick={handleSave}>Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default Configurations;
